import type { TourTranslation } from "./index";

export const italian = {
  ap_label: "Gestione delle eccezioni in contabilità fornitori",
  ap_intro_title: "La fatturazione nei team contabili",
  ap_intro_lead: "Questa è una demo della fatturazione nei team contabili.",
  ap_intro_body:
    "L'elaborazione delle fatture è sempre più automatizzata, ma le eccezioni richiedono ancora lavoro manuale. La metrica chiave sono gli interventi manuali per fattura. Ma come si individuano i problemi a monte che li causano?",
  ap_failures_body:
    "Platonic mappa i tuoi flussi di lavoro, rivelando tre tipi di errore: discrepanze di prezzo sui PO, discrepanze di quantità e ricevute mancanti.",
  ap_filter_body:
    "Le discrepanze di prezzo possono rivelare problemi a monte. Platonic ti permette di approfondirle descrivendole in linguaggio naturale.",
  ap_filter_prompt: "PO Invoice price mismatch",
  ap_ask_body:
    "L\u0027indagine manuale richiede tempo. Chiediamolo direttamente al processo. Prova: \u201cWhy is there a price mismatch between POs and invoices?\u201d",
  ap_prompt: "Why is there a price mismatch between POs and invoices?",
  ap_answer_body:
    "La chat ha rivelato che pochi articoli causano la maggior parte delle eccezioni: contratti obsoleti nel sistema PO generano discrepanze ricorrenti.",
  ap_monitor_body:
    "Aggiornare i PO interessati risolve il problema, ma può ripresentarsi con altri contratti. Come si intercetta in anticipo?",
  ap_watch_prompt: "Find a list of items that lead to recurring invoice PO price mismatch.",
  ap_watch_title: "PO non aggiornati",
  ap_kpi_body:
    "Platonic ti fa tracciare i PO non aggiornati come KPI, con un report periodico direttamente nella tua casella, ad es. \u201cFind a list of items that lead to recurring invoice PO price mismatch\u201d.",
  hr_label: "Rischio persone-chiave nei team HR",
  hr_intro_title: "Rischio persone-chiave nei team HR",
  hr_intro_body:
    "Un fondo di private equity ha acquisito un'azienda. Prima di centralizzare, esternalizzare o ridisegnare l'HR, deve capire dove risiede la conoscenza critica e quali processi dipendono da persone specifiche.",
  hr_map_body: "Prendiamo come esempio il processo di screening dei candidati…",
  hr_inspect_body:
    "…una rapida ispezione mostra che i dipendenti si affidano spesso l'uno all'altro nei casi pi\u00f9 complessi.",
  hr_ask_body:
    "Platonic ti permette di interrogare direttamente il processo e capire il contesto dietro queste consultazioni.",
  hr_prompt: "Provide context on why a colleague was consulted in this task",
  hr_answer_body:
    "La chat ha rivelato che un dipendente gestisce la maggior parte di questi casi e detiene la conoscenza critica per risolvere i casi limite.",
  hr_monitor_body: "Ma come individuare lo stesso schema in tutti i processi della funzione?",
  hr_wask_body:
    "Puoi chiedere direttamente a Platonic di analizzare come è distribuito il lavoro nel team HR e individuare rischi persone-chiave e dipendenze operative.",
  hr_watch_prompt:
    "Analyze how work is distributed across the HR team and identify any key-person risks or operational dependencies. Who holds unique process knowledge, who is most frequently relied on by colleagues, which activities depend disproportionately on specific individuals, and what risks would arise if one person were unavailable?",
  hr_wanswer_body:
    "L'analisi ha confermato che un dipendente è il fulcro operativo del team HR e detiene gran parte della conoscenza necessaria ai suoi processi.",
  cs_label: "Lacune di conoscenza nel Customer Service",
  cs_intro_title: "Lacune di conoscenza nel Customer Service",
  cs_intro_body:
    "I team di Customer Service si affidano a knowledge base e playbook. Quando sono incompleti o obsoleti, i casi richiedono più tempo, ricerche, interazioni ed escalation. Come si individuano le lacune?",
  cs_filter_body:
    "Platonic ti permette di zoomare su casi specifici descrivendole in linguaggio naturale.",
  cs_filter_prompt: "top 10 longest time",
  cs_node_body:
    "I casi più lunghi passano un tempo sproporzionato a cercare nella knowledge base. Ispezioniamo quel passaggio.",
  cs_insight_body:
    "Queste ricerche sono lente e spesso portano a escalation invece che a risoluzione, segno di lacune nella knowledge base. Ma quali lacune causano il problema?",
  cs_ask_body: "Platonic ti permette di interrogare direttamente il processo.",
  cs_prompt: "Which gaps/ambiguity in the policies emerge from these processes?",
  cs_answer_body:
    "L\u0027analisi evidenzia lacune ricorrenti su diritti di recesso UE, rinnovi automatici, rimborsi dei reseller e piani legacy.",
  cs_monitor_body:
    "Una volta colmate le lacune, come fai a sapere che le nuove linee guida funzionano davvero?",
  cs_watch_prompt:
    "Find unresolved knowledge-base searches and the escalation rate that follows them. Highlight recurring topics where agents fail to find relevant guidance, and show whether these gaps improve over time.",
  cs_watch_title: "Lacune KB",
  cs_kpi_body:
    "Platonic ti permette di monitorare le lacune della knowledge base come KPI, con un report periodico direttamente nella tua casella, ad es. \u201cFind unresolved knowledge-base searches and the escalation rate that follows them, highlight recurring topics where agents fail to find relevant guidance, and show whether these gaps improve over time\u201d.",
  demo_label: "Gestione dei costi negli acquisti",
  demo_intro_lead: "Questa è una demo sulla gestione dei costi nei team di procurement.",
  demo_intro_body:
    "I costi di acquisto dipendono dai contratti negoziati. Rinegoziare termini deboli o cambiare fornitore può ridurre i costi in modo sostanziale. Ma come si individuano queste opportunità?",
  start: "Inizia",
  demo_blueprint_body:
    "Platonic registra l'attività dello schermo, i clic e l'uso delle applicazioni nel tuo team e la trasforma in un progetto di come il lavoro viene svolto davvero.",
  demo_graph_body: "I processi reali sono difficili da leggere…",
  demo_map_body: "Platonic mappa i flussi di lavoro della tua azienda.",
  demo_deviations_body:
    "Una deviazione comune dalla procedura standard è la ricerca esterna di fornitori, che può aumentare i costi. Verifichiamo se è così.",
  demo_ask_body:
    "Platonic ti permette di interrogare direttamente il processo. Prova: “Mostra una tabella di articoli unici con costo medio per fornitori con e senza contratto”.",
  demo_prompt:
    "Mostra una tabella di articoli unici con costo medio per fornitori con e senza contratto",
  demo_watch_prompt:
    "Individua tutti gli acquisti con un fornitore esterno quando ne era disponibile uno a contratto",
  demo_watch_title: "Utilizzo di fornitori senza contratto",
  demo_answer_body:
    "I dati confermano che i fornitori fuori contratto costano sensibilmente più di quelli a contratto.",
  demo_monitor_body: "La soluzione è far rispettare i contratti, ma come lo si monitora?",
  demo_kpi_body:
    "Platonic ti fa tracciare gli acquisti fuori contratto come KPI, con un report periodico direttamente nella tua casella, ad es. “Individua tutti gli acquisti con un fornitore esterno quando ne era disponibile uno a contratto”.",
  demo_cta_title: "Pronto ad approfondire?",
  demo_cta_body: "Scopri cosa trova Platonic nel lavoro del tuo team.",
  demo_cta_hint:
    "Puoi prenotare una demo dal vivo in qualsiasi momento con il pulsante in basso a destra.",
  demo_book_demo: "Prenota una demo",
  demo_request_access: "Richiedi accesso",
  demo_waitlist_name_placeholder: "Nome e cognome",
  demo_waitlist_email_placeholder: "Email di lavoro",
  demo_waitlist_area_label: "Quale area vorresti migliorare con Platonic?",
  demo_waitlist_area_placeholder: "Scegli un'area",
  demo_waitlist_area_other_placeholder: "Quale?",
  demo_waitlist_area_procurement: "Acquisti",
  demo_waitlist_area_finance: "Finanza",
  demo_waitlist_area_customer_service: "Servizio clienti",
  demo_waitlist_area_supply_chain: "Supply chain",
  demo_waitlist_area_operations: "Operations",
  demo_waitlist_area_sales: "Vendite",
  demo_waitlist_area_human_resources: "Risorse umane",
  demo_waitlist_area_it: "IT",
  demo_waitlist_area_other: "Altro",
  demo_waitlist_done_title: "Sei in lista d'attesa.",
  demo_waitlist_done_body:
    "Esamineremo la tua richiesta e ti invieremo le istruzioni di installazione non appena l'accesso sarà pronto.",
  demo_waitlist_error: "Qualcosa è andato storto. Riprova.",
  welcome_body: "Benvenuto! Questa demo offre funzionalità limitate.",
  welcome_cta_prefix: "Per accedere a tutte le funzionalità del prodotto, ",
  welcome_cta_link: "prenota una demo",
  welcome_gallery: "Scopri la nostra libreria di casi d'uso per vedere Platonic in azione.",
  target_missing_toast_title: "Tour terminato",
  target_missing_toast_message:
    "Questa parte dell'app non è disponibile al momento. Riprova quando ci saranno dati da mostrare.",
  back: "Indietro",
  next: "Avanti",
  done: "Fatto",
  settings_title: "Guida introduttiva",
  settings_help: "La demo guidata del prodotto.",
  demo_user_import: "Utenti demo",
  demo_user_import_card_description:
    "Crea le persone di una demo da un solo file, ed elimina l'intera demo quando è finita.",
  demo_user_import_description:
    "Ogni demo è una società a sé, così può essere filtrata ed eliminata come unità.",
  demo_user_credentials: "Credenziali",
  demo_user_credentials_warning:
    "Queste password vengono mostrate una sola volta e non sono salvate in chiaro da nessuna parte. Scaricale ora se ti servono.",
  download_csv: "Scarica CSV",
  select_demo_company: "Seleziona una società",
  demo_import: "Importa una demo",
  demo_import_description:
    "Trascina una cartella con un manifest.json e un file di analisi per sessione. Ripetere il drop è sicuro: le persone già esistenti vengono saltate e le sessioni aggiornate.",
  demo_drop_folder: "Trascina qui la cartella della demo",
  demo_choose_folder: "oppure scegli una cartella",
  demo_import_action: "Importa demo",
  demo_retry_failed: "Riprova i falliti",
  demo_manifest_missing: "La cartella deve contenere un {{name}}.",
  demo_manifest_unreadable: "Impossibile leggere il manifest.",
  demo_bundle_summary: "{{users}} persone · {{sessions}} sessioni",
  demo_company_outside_band: "L'id società {{id}} è fuori dalla banda demo {{min}}–{{max}}.",
  demo_owners_not_in_manifest:
    "Questi proprietari non sono nel manifest e devono già esistere: {{owners}}",
  demo_files_missing: "{{count}} file indicati nel manifest non sono nella cartella: {{files}}",
  demo_session_progress: "{{done}} di {{total}} completati",
  demo_failed_count: "{{count}} falliti",
  demo_owner_unresolved: 'Nessun utente di nome "{{owner}}"',
  demo_file_unreadable: "Il file di analisi non è JSON valido",
  demo_no_owner: "nessun proprietario",
  demo_usernames_taken:
    "Questi nomi utente appartengono già ad account fuori da questa demo, quindi non è stato creato nulla: {{users}}",
  demo_users_skipped: "{{count}} persone esistevano già e sono state lasciate invariate: {{users}}",
  demo_contents: "Contenuto delle demo",
  demo_contents_description:
    "Qui compaiono solo le persone create per le demo, ed è l'unica cosa eliminabile: un account reale non è mai raggiungibile da questa pagina.",
  delete_demo_user: "Elimina {{username}}",
  delete_demo_session: "Elimina sessione",
  delete_whole_demo: "Elimina tutta la demo {{name}}",
  n_sessions: "{{count}} sessioni",
  n_sessions_one: "{{count}} sessione",
  no_demo_companies_to_delete:
    "Nessuna demo da eliminare. Le società con utenti reali non compaiono qui.",
} satisfies TourTranslation;
